import { escapeRegExp } from "lodash";

export function createMeetingFilter(filter) {
    const filters = [];

    if (filter.text) {
        const exp = new RegExp(escapeRegExp(filter.text), 'i');

        filters.push((meeting) => meeting.name.match(exp));
        filters.push(meeting => meeting.invited.some(invite => invite.user.first_name.match(exp) || invite.user.last_name.match(exp)));
        filters.push(meeting => meeting.initiator.first_name.match(exp) || meeting.initiator.last_name.match(exp));
    }

    return (meeting) => filters.some((f) => f(meeting));
}
